import { controlToastState } from "risa-oasis-ui_v2";
import { ingestPdfCsvNarGrid } from "../../../../../api/postCall/ingestPdfCsvNarGrid";
import { generateNarGcsFilePath } from "../utils/generateNarFilePath";

interface HandleNarIngestionApiCallParams {
  payerType: string;
  subType: string;
  month: number;
  year: number;
  documentType: string;
  ingest: boolean;
  day?: number;
  onSuccess?: () => void;
  setIsSubmitting?: (isSubmitting: boolean) => void;
}

export const handleNarIngestionApiCall = async ({
  payerType,
  subType,
  month,
  year,
  documentType,
  ingest,
  day,
  onSuccess,
  setIsSubmitting,
}: HandleNarIngestionApiCallParams) => {
  try {
    if (setIsSubmitting) {
      setIsSubmitting(true);
    }

    // Convert to numbers and validate
    const monthNum = Number(month);
    const yearNum = Number(year);
    const dayNum = day ? Number(day) : undefined;

    // Validate that month and year are valid numbers
    if (isNaN(monthNum) || isNaN(yearNum)) {
      controlToastState(
        ingest ? "nar-ingestion-approved-failure" : "nar-ingestion-failure",
      );
      if (setIsSubmitting) {
        setIsSubmitting(false);
      }
      return;
    }

    const bucketName =
      process.env.REACT_APP_ENV === "production"
        ? "prior-auth-portal-prod.appspot.com"
        : "prior-auth-portal-dev.appspot.com";

    // Use provided day or calculate the last day of the month
    const dayOfMonth = dayNum || new Date(yearNum, monthNum, 0).getDate();

    // Generate effective_date in YYYY-MM-DD format
    const effectiveDate = `${yearNum}-${String(monthNum).padStart(2, "0")}-${String(dayOfMonth).padStart(2, "0")}`;

    // Generate file path with auth_grid prefix
    const gcsFilePath = generateNarGcsFilePath(
      payerType,
      subType,
      dayOfMonth,
      monthNum,
      yearNum,
      documentType,
      bucketName,
      true, // includeAuthGrid for file_path
    );

    const gcsFileUrl = generateNarGcsFilePath(
      payerType,
      subType,
      dayOfMonth,
      monthNum,
      yearNum,
      documentType,
      bucketName,
      false,
    );

    const payload = {
      file_type: documentType,
      ingest: ingest,
      payer_type: payerType,
      effective_date: effectiveDate,
      sub_type: subType,
      version: "latest",
      artifact_creation_date: new Date().toISOString(),
      bigquery_table: "auth_grid",
      bigquery_dataset: "auth_verification",
      client_bigquery_table: "client_config",
      file_url: gcsFileUrl,
      file_path: gcsFilePath,
    };

    try {
      await Promise.race([
        ingestPdfCsvNarGrid(payload),
        new Promise((resolve) => setTimeout(resolve, 5000)).then(() => ({
          success: true,
        })),
      ]);

      if (setIsSubmitting) {
        setIsSubmitting(false);
      }
      onSuccess?.();
    } catch (error) {
      console.error("Error ingesting NAR grid:", error);
      controlToastState("nar-ingestion-failure");
      if (setIsSubmitting) {
        setIsSubmitting(false);
      }
      onSuccess?.();
      return;
    }
  } catch (error) {
    const errorToastId = ingest
      ? "nar-ingestion-approved-failure"
      : "nar-ingestion-failure";
    controlToastState(errorToastId);

    if (setIsSubmitting) {
      setIsSubmitting(false);
    }
  }
};
